import {CommonModule} from '@angular/common';
import {Clipboard, ClipboardModule} from '@angular/cdk/clipboard';
import {
  Component, Input, Output, EventEmitter,
  ViewChild, TemplateRef,
  ElementRef,
  AfterViewInit, OnInit, ChangeDetectorRef,
  inject, ViewChildren, QueryList
} from '@angular/core';
import {NgIf, NgTemplateOutlet, NgForOf, SlicePipe} from '@angular/common';
import {ActivatedRoute, Router,} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {RxAuthService} from 'src/app/services/rx-auth/rx-auth.service';
import {MediaQueryService} from 'src/app/services/media-query/media-query.service';
import {DialogComponent} from 'src/app/shared/toolbox/dialogs/dialog/dialog.component';
import {CompareDialogComponent} from 'src/app/shared/toolbox/dialogs/compare-dialog/compare-dialog.component';
import {
  TabularDataDownloadDialogComponent
} from 'src/app/shared/toolbox/dialogs/tabular-data-download-dialog/tabular-data-download-dialog.component';
import {environment} from 'src/environments/environment';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faDatabase, faFileLines, faLock,
  faPlus, faShareNodes, faUpload, faPhone
} from '@fortawesome/free-solid-svg-icons';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import html2canvas from 'html2canvas';
import PptxGenJS from 'pptxgenjs';
import * as QRCode from 'qrcode';
import 'reflect-metadata';
import {firstValueFrom, map} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';
import {
  clusterData, rankingData, retailerData,
  sectorData
} from 'src/app/shared/toolbox/dialogs/compare-dialog/compareDialogInterfaces';
import {SelectedFilters} from 'src/app/explore/explorer/explorerInterfaces';
import {Signal} from '@angular/core';
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  ContactPhoneDialogComponent
} from "../../shared/toolbox/dialogs/contact-phone-dialog/contact-phone-dialog.component";
import { CompareService } from '../../services/compare/compare.service';


@Component({
  selector: 'app-profile-top-matter',
  standalone: true,
  styleUrls: ['./profile-top-matter.component.scss'],
  imports: [
    NgIf,
    ClipboardModule,
    CommonModule,
    NgTemplateOutlet,
    CompareDialogComponent,
    DialogComponent,
    FontAwesomeModule,
    NgForOf,
    SlicePipe,
    TabularDataDownloadDialogComponent,
    MatTooltipModule,
    ContactPhoneDialogComponent,
  ],
  templateUrl: './profile-top-matter.component.html'
})
export class ProfileTopMatterComponent implements OnInit, AfterViewInit {
  @Input() templateType: string = 'default';
  @Input() profile: any | null = {};
  @Input() echelonNameWithSpaces: string = '';
  @Input() selectedList: any | null
  @Input() publicView: boolean | null = null;
  @Input() isIframe: boolean | null = null;

  @ViewChild('retailerTemplate', {static: true}) retailerTemplate!: TemplateRef<any>;
  @ViewChild('rankingTemplate', {static: true}) rankingTemplate!: TemplateRef<any>;
  @ViewChild('defaultTemplate', {static: true}) defaultTemplate!: TemplateRef<any>;
  @ViewChild('sectorTemplate', {static: true}) sectorTemplate!: TemplateRef<any>;
  @ViewChild('regionTemplate', {static: true}) regionTemplate!: TemplateRef<any>;

  @ViewChild('exportDropdown') exportDropdown!: ElementRef;
  @ViewChildren('echelonElement', {read: ElementRef}) echelonElements!: QueryList<any>;


  templates: { [key: string]: TemplateRef<any> } = {};

  // RETAILER VAR START
  public plusIcon = faPlus as IconProp;
  public shareIcon = faShareNodes as IconProp;
  // public uploadIcon = faUpload as IconProp;
  public dataIcon = faDatabase as IconProp;
  public reportIcon = faFileLines as IconProp;
  public lockIcon = faLock as IconProp;

  isRetailerOnly = false;
  phoneCopiedMessage = false;
  showDownloadDialog = false;
  showSupplierDownloadDialog = false;
  showPhoneDialog = false;
  tooltipText = '';
  tooltipX = 0;
  tooltipY = 0;
  tableIsExpanded = false;
  explorerFilters: SelectedFilters = {
    region: [], cluster: [], sigMarket: [], hq: [], sector: [], ranking: [],
    companyType: [], businessType: [], supplierCategory: [], supplier: [], product: [],
  };
  showdata = false;
  // RETAILER VAR END

  // LIST VAR START
  public sponsorIcons = [];
  padlockUrl: string = environment.wp.sign_up_url;
  // comparedToRetailer: any = null;
  echelonHeaders: string[] = [];
  // availableEchelons: any[] = []
  showListDownloadDialog = false;
  showRankedRetailersDownloadDialog = false;
  // LIST VAR END

  displayDialog: boolean = false;

  showCompareDialog: boolean = false;
  combinedSelected: (retailerData | rankingData | sectorData | clusterData)[] = [];
  compareID: string | null = null;
  displayExportDropdown: boolean = false;
  displayExportSpinner: boolean = false;

  shareUrl: any = null;
  embedCode: any = null;
  contentType: string = '';

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    public dialog: DialogComponent,
    public auth: RxAuthService,
    public elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public snack: MatSnackBar,
    private clipboard: Clipboard,
    private compareService: CompareService,
  ) {

  }

  private mediaQueryService: MediaQueryService = inject(MediaQueryService);
  public isMobile: Signal<boolean> = toSignal(
    this.mediaQueryService.getDisplayType().pipe(map(({isMobile}) => isMobile)),
    {initialValue: window.innerWidth < 767}
  );

  ngOnInit() {
    this.contentType = `single-${this.templateType}`
    if (this.templateType == 'retailer' || this.templateType == 'supplier') {
      this.setComparePills();
      this.isRetailerOnly = !this.profile.current_list;
      this.setRetailerProfile();

      if (this.profile.retailer.is_vendor) {
        this.explorerFilters.supplier.push({
          name: this.profile.retailer.name,
          categories: this.profile.retailer.product_categories.map((item: any) => item.name),
          id: this.profile.retailer.retailer_id
        });
      }
      this.showdata = true;
    } else if (this.templateType == 'list') {

      this.selectedList = this.profile.current_list;
      this.compareID = this.route.snapshot.queryParamMap.get('compare')
      if (this.compareID) {
        this.setComparePillsList()
      }

      this.selectedList = this.profile.all_lists.find(
        (list: any) => list.name == this.profile.current_list.name
      );
      let expanded = this.route.snapshot.queryParamMap.get('expanded');
      //console.log(this.profile)
      if (expanded === 'true') {
        this.tableIsExpanded = true;
      }

      // Sort retailers by name within each cluster
      if (this.profile.list_cluster_object) {
        this.profile.list_cluster_object.forEach((cluster: any) => {
          cluster.retailers.sort((a: any, b: any) =>
            a.name.localeCompare(b.name)
          );
        });
      }

      this.updateSponsorIcons(this.profile);
    } else if (this.templateType == 'sector') {
      if (!this.auth.isStaffUser()) {
        this.showdata = true;
      } else {
        this.showdata = false;
      }
    } else if (this.templateType == 'region') {
      if (!this.auth.isStaffUser()) {
        this.showdata = true;
      } else {
        this.showdata = false;
      }
    }
  }

  ngAfterViewInit(): void {
    this.templates = {
      retailer: this.retailerTemplate,
      supplier: this.retailerTemplate,
      list: this.rankingTemplate,
      sector: this.sectorTemplate,
      region: this.regionTemplate,
      default: this.defaultTemplate,

    };
    this.cdr.detectChanges();

    if (this.templateType == 'list') {
      this.route.queryParams.subscribe((params: any) => {
        if (Object.keys(params).length > 0 && this.profile.echelons.length > 0 && 'echelon' in params) {
          const echelonNameWithDashes = params['echelon'];
          this.echelonNameWithSpaces = this.replaceDashWithSpace(echelonNameWithDashes)
        } else {
          console.log("continue")
        }
      });
      this.getEchelonHeaders();
    }
    // try {
    //   this.isIframe = window.self !== window.top;
    // } catch (e) {
    //   this.isIframe = true;
    // }

    }

  functionHandler(fn: (...args: any[]) => void, ...args: any[]): void {
    const authToken = localStorage.getItem('jwt_access');
    if (!authToken) {
      window.open(environment.wp.frontend_base + 'login', '_blank')

    } else {
      if (!this.isIframe) {
        fn.apply(this, args);
      } else {

        this.goToFullProfile()
      }
    }
  }

  goToFullProfile() {
    window.open(environment.frontend_base + 'profile?id=' + this.profile.rcl_id, '_blank')
  }

  copyEmbedCode(type: string) {
    let width = ''
    let height = ''

    if (type === 'fixed') {
      width = '600px'
      height = '500px'
    } else if (type === 'responsive') {
      width = '55vw'
      height = '75vh'
    }
    // width:50vw;height:60vh

    this.shareUrl = `${environment.frontend_base}profile?id=${this.profile.rcl_id}`
    this.embedCode = `<iframe frameborder="0" style='width:${width};height:${height};align-content: center; justify-content: center; align-items: center;' src='${this.shareUrl}'></iframe>`
    this.clipboard.copy(this.embedCode)
    let snackRef = this.snack.open('The embedding code has been copied to your clipboard', 'Accept')

    snackRef._dismissAfter(3000)

  }

  // RETAILER TEMPLATE FUNCTIONS START
  get displayHqFlag(): string {
    if (this.profile?.retailer?.hq_region?.code) {
      const flag = this.profile.retailer.hq_region.code.toLowerCase();
      if (flag === 'eea') return 'eu';
      if (flag === 'all') return 'un';
      return flag;
    }
    return this.profile.retailer.hq_region.code;
  }

  getCleanUrl(): string {
    const url = this.profile?.retailer?.landing_page || '';
    return url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
  }

  toggleShareDialog() {
    this.displayDialog = !this.displayDialog;
  }

  toggleCompareDialog() {
    this.showCompareDialog = !this.showCompareDialog;
    if (
      !this.showCompareDialog &&
      this.route.snapshot.queryParamMap.get('compare')
    ) {
      console.log('CompareTo emmitted')
      console.log(this.route.snapshot.queryParamMap.get('compare'))
      this.compareService.triggerCompare(this.route.snapshot.queryParamMap.get('compare'));
      this.setComparePills()
    }
  }

  downloadProfile(response?: boolean): Promise<any> | undefined {
    this.toggleExportDropdown(); // Start hiding the dropdown
    this.displayExportSpinner = true;
    const topmatter = this.elementRef.nativeElement.querySelector('.topmatter');
    const ignoreFunction = (element: Element): boolean => {
      return element.classList.contains('ignore-on-download')
    }

    if (response) {
      // Create a Promise that resolves/rejects when html2canvas finishes inside setTimeout
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          html2canvas(topmatter, {
            useCORS: true,
            foreignObjectRendering: false,
            ignoreElements: ignoreFunction
          }).then(canvas => {
            let final_object = {
              dimensions: {
                width: canvas.width,
                height: canvas.height
              },
              image: canvas.toDataURL('image/png')
            };
            // Don't hide spinner here, let the caller (downloadPPT) handle it
            resolve(final_object); // Resolve the promise with the result
          }).catch(error => {
            console.error("html2canvas failed:", error);
            this.displayExportSpinner = false; // Ensure spinner hides on error
            reject(error); // Reject the promise on error
          });
        }, 0); // Defer html2canvas execution
      });
    } else {
      // Just trigger the download, no promise needed to be returned synchronously.
      setTimeout(() => {
        html2canvas(topmatter, {
          useCORS: true,
          foreignObjectRendering: false,
          ignoreElements: ignoreFunction
        }).then(canvas => {
          const image = canvas.toDataURL('image/png');
          const link = document.createElement('a');
          link.href = image;
          link.download = `${this.profile.retailer.name} Company Profile.png`;
          link.click();
          this.displayExportSpinner = false; // Hide spinner after download starts
        }).catch(error => {
          console.error("html2canvas failed:", error);
          this.displayExportSpinner = false; // Ensure spinner hides on error
          // Optionally, show an error message to the user
        });
      }, 0); // Defer html2canvas execution
      return undefined; // Return undefined for the non-response case
    }
    // Now the function synchronously returns Promise<any> if response=true,
    // and undefined otherwise, matching the declared type.
  }

  downloadQRCode(response?: boolean): Promise<any> | undefined {
    this.displayExportSpinner = true;

    // Get the current URL (or a custom URL)
    const currentUrl = window.location.href; // You can replace this with any URL you want to encode

    // If response is true, return the QR code URL as an object
    if (response) {
      return QRCode.toDataURL(currentUrl, {errorCorrectionLevel: 'H'})
        .then((qrCodeUrl: string) => {
          this.displayExportSpinner = false; // Hide spinner once QR code is generated
          return {qrCodeUrl}; // Return QR code URL as an object
        })
        .catch((err: any) => {
          console.error('Error generating QR code:', err);
          this.displayExportSpinner = false; // Hide spinner on error
          return undefined; // Return undefined in case of an error
        });
    } else {
      // If response is false (or not provided), generate and download the QR code as an image
      QRCode.toDataURL(currentUrl, {errorCorrectionLevel: 'H'})
        .then((qrCodeUrl: string) => {
          // Create a link to download the QR code image
          const qrCodeLink = document.createElement('a');
          qrCodeLink.href = qrCodeUrl;
          qrCodeLink.download = `QRCode-${new Date().toISOString()}.png`; // Generate a name for the file
          qrCodeLink.click();

          // Hide the export spinner once the download is triggered
          this.displayExportSpinner = false;
        })
        .catch((err: any) => {
          console.error('Error generating QR code:', err);
          this.displayExportSpinner = false; // Hide spinner on error
        });
    }

    return undefined; // Default return value if neither response nor download happens
  }

  async downloadPPT() {
    this.displayExportSpinner = true

    let profileImage = await this.downloadProfile(true)
    let dimensions = profileImage.dimensions
    profileImage = profileImage.image

    const pptx = new PptxGenJS()

    let thumbnail_url = `${environment.backend_base}main/retailer/get_rcl_thumbnails/`
    let payload = {'rcl': this.profile.rcl_id}


    // Await the post request
    let response: any = await firstValueFrom(this.http.post(thumbnail_url, payload));
    let chart_thumbnails: string[] = response.data;

    let firstSlide = pptx.addSlide()

    const width = dimensions.width;
    const height = dimensions.height;
    const aspectRatio = height / width;

    let targetWidth = 9; // inches
    let targetHeight = targetWidth * aspectRatio;
    let profile_x = 0.5
    let profile_y = 1

    if (this.isMobile()) {
      targetHeight = 5
      targetWidth = targetHeight * (width / height)
      profile_x = 4
      profile_y = 0.5
    }

    firstSlide.addImage({path: profileImage, x: profile_x, y: profile_y, w: targetWidth, h: targetHeight})

    for (let item of chart_thumbnails) {
      let slide = pptx.addSlide()
      slide.addImage({path: item, x: 1.6, y: 1, w: 7, h: 4})
    }

    pptx.writeFile({fileName: `${this.profile.retailer.name}.pptx`})

    this.displayExportSpinner = false

  }

  showTooltip(text: string | Array<any>, prefix?: string) {

    if (Array.isArray(text)) {
      text = text.map((m) => m.name).join(', ');
    }
    if (prefix) {
      text = prefix + text
    }
    this.tooltipText = text


    setTimeout(() => {
      this.tooltipText = ''
    }, 3000)
  }

  hideTooltip() {
    this.tooltipText = '';
  }

  updateTooltipPosition(event: MouseEvent) {
    this.tooltipX = event.clientX - 30;
    this.tooltipY = event.clientY + 10;
  }

  listRedirect(item: any) {
    window.location.href = environment.frontend_base + 'profile?id=' + item?.ranking.rcl
  }

  toggleExportDropdown() {
    this.displayExportDropdown = !this.displayExportDropdown
    // if(this.showDownloadDialog) {
    //   this.showDownloadDialog = false
    // }
    if (this.displayExportDropdown) {
      setTimeout(() => {
        this.exportDropdown.nativeElement.focus()
      })

    }

  }

  togglePhoneDialog() {
    this.showPhoneDialog = !this.showPhoneDialog
    this.cdr.detectChanges();
  }

  get numberRetailers(): any[] {
    return (this.profile?.top_level_data as any)?.number_retailers || []
  }

  get significantMarkets(): any[] {
    return (this.profile?.significant_markets as any) || []
  }

  get rankingTable(): any[] {
    return (this.profile?.top_level_data.ranking_table as any) || []
  }

  toggleDownloadDialog() {
    if (!this.showDownloadDialog) {
      this.displayExportDropdown = !this.displayExportDropdown
    }

    this.showDownloadDialog = !this.showDownloadDialog;
  }

  setComparePills() {
    let current_page_ID = this.route.snapshot.queryParamMap.get('id')
    this.compareID = this.route.snapshot.queryParamMap.get('compare')

    if (this.compareID) {
      let url = `${environment.backend_base}main/retailer/get_rcls_compare_profile_pill_info/`
      let payload = {
        rcls: this.compareID,
        current_id: current_page_ID,
      }
      this.http.post(url, payload).subscribe((response: any) => {
          this.combinedSelected = response

          this.combinedSelected = this.combinedSelected.map((item: any) => {
            if ((item.type === 'cluster' || item.type === 'sector') && item.in_list_name) {
              return {
                ...item,
                name: `${item.name} (${item.in_list_name})`
              };
            }
            return item;
          });
          this.cdr.detectChanges()

        }, (error) => {
          console.error("Error when accessing compare pill information: ", error)
        }
      )
    }

  }

  async setRetailerProfile() {
    let slug = this.route.snapshot.queryParamMap.get('slug')
    let id = this.route.snapshot.queryParamMap.get('id')
    let expanded = this.route.snapshot.queryParamMap.get('expanded')

    if (expanded === 'true') {
      this.tableIsExpanded = true
    }

    let payload = null

    if (id) {
      payload = {rcl: id}
    } else {
      payload = {slug: slug}
    }


  }

  // RETAILER TEMPLATE FUNCTIONS END


  // List TEMPLATE FUNCTIONS START
  setComparePillsList() {
    let current_page_ID = this.route.snapshot.queryParamMap.get('id')

    let url = `${environment.backend_base}main/retailer/get_rcls_compare_profile_pill_info/`
    let payload = {
      rcls: this.compareID,
      current_id: current_page_ID,
    }
    this.http.post(url, payload).subscribe((response: any) => {
        this.combinedSelected = response
        this.combinedSelected = this.combinedSelected.map((item: any) => {
          if ((item.type === 'cluster' || item.type === 'sector') && item.in_list_name) {
            return {
              ...item,
              name: `${item.name} (${item.in_list_name})`
            };
          }
          return item;
        });
      }, (error) => {
        console.error("Error when accessing compare pill information: ", error)
      }
    )
    console.log(this.combinedSelected)
    this.cdr.detectChanges()
  }

  scrollToMatchingEchelon() {
    setTimeout(() => {
      const matchingEchelon = this.echelonElements.toArray().find((elementRef) => {
        const headerElement = elementRef.nativeElement.querySelector('.echelon-header p:first-child');
        return headerElement &&
          headerElement.innerText.trim().toLowerCase() === this.echelonNameWithSpaces?.trim().toLowerCase();
      });


      if (matchingEchelon) {
        const elementPosition = matchingEchelon.nativeElement.getBoundingClientRect().top + window.scrollY;
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;

        // Scroll to the target element ensuring it aligns at the very top
        window.scrollTo({
          top: elementPosition - headerHeight,
          behavior: 'smooth'
        });

        // Wait for the scroll animation to finish, then open the echelon
        setTimeout(() => {
          const echelonComponent = matchingEchelon.componentInstance; // Access the Angular component instance
          // Trigger the click event on the expand button in the footer to toggle content
          const footerElement = matchingEchelon.nativeElement.querySelector('.echelon-footer .expand-button');
          if (footerElement) {
            footerElement.click(); // Trigger the click event to toggle content
          }

        }, 1000); // Adjust this delay to match the scroll duration

      } else {
        console.warn('Matching echelon not found:', this.echelonNameWithSpaces);
      }
    }, 1000); // Ensure the DOM is fully rendered before scrolling
  }

  getEchelonHeaders(retryCount = 0, maxRetries = 10) {
    setTimeout(() => {
      const headers = this.echelonElements.toArray().map((elementRef) => {
        const headerElement = elementRef.nativeElement.querySelector('.echelon-header p:first-child');

        if (headerElement) {
          return {
            text: headerElement.innerText,
            position: headerElement.getBoundingClientRect().top + window.scrollY
          };
        }
        return null;
      }).filter(header => header !== null);

      if (headers.length === 0 && retryCount < maxRetries) {
        console.warn(`Retrying... Attempt ${retryCount + 1}`);
        this.getEchelonHeaders(retryCount + 1, maxRetries);
      } else {
        this.echelonHeaders = headers.map(header => header?.text);
        this.scrollToMatchingEchelon()// Extract only text values
      }
    }, 300); // Adjust delay if needed
  }

  replaceDashWithSpace(dashedString: string): string {
    return dashedString.replace(/-/g, ' '); // Replaces all dashes with spaces
  }

  profileExpandSwitch() {
    this.tableIsExpanded = !this.tableIsExpanded;
  }

  getUrlToRedirect(i: any) {
    let url = `profile?id=${i.id}&slug=${i.slug}`;
    if (this.tableIsExpanded) {
      url += '&expanded=true';
    }
    return url;
  }

  redirectToUrl(i: any) {
    // console.log(this.profile);
    if (this.auth.isPremiumUser() || this.auth.isEssentialUser() || this.auth.isStaffUser() || i.is_basic_accessible
    ) {
      let url = this.getUrlToRedirect(i);
      window.location.href = url;
    } else {
      let snackRef = this.snack.open(
        'Please upgrade your account to access this resource',
        'Upgrade now'
      );
      snackRef.onAction().subscribe((action: any) => {
        console.log('UPGRADING');
        window.location.href = `${environment.wp.sign_up_url}`;
      });
      snackRef._dismissAfter(5000);
    }
  }

  getAlternativeImageUrl(): string {
    return 'https://accounts-app.s3.eu-west-1.amazonaws.com/RetailDNA_Icon.svg'; // Replace with your actual alternative image URL
  }

  toggleShareDialogList() {
    this.displayDialog = !this.displayDialog;
  }

  toggleCompareDialogList() {
    this.showCompareDialog = !this.showCompareDialog;
    if (
      !this.showCompareDialog &&
      this.route.snapshot.queryParamMap.get('compare')
    ) {
      console.log('compareTo emitted');
      this.compareService.triggerCompare(this.route.snapshot.queryParamMap.get('compare'));
    }
  }

  redirectToDownloadable() {
    // location.href = `${environment.retailx_base}retail-rankings/`;
    location.href = this.profile.current_list.relevant_links[0].data;
  }

  redirectToReports() {
    // if (this.profile.current_list.rcl === 6066) { //Global ranking
    //   location.href = `${environment.wp.frontend_base}report-hub/global-360-top1000-report-2024/`
    // } else if (this.profile.current_list.rcl === 4872) { //UK ranking
    //   location.href = `${environment.wp.frontend_base}report-hub/retailx-uk-top500-2024/`
    // } else if (this.profile.current_list.rcl === 2579) { // EU ranking
    //   location.href = `${environment.wp.frontend_base}report-hub/retailx-top1000-europe-report-2024/`
    // }
    //location.href = `${environment.retailx_base}retail-rankings/`

    location.href = this.profile.current_list.relevant_links[0].report;
  }

  updateSponsorIcons(listProfile: any) {
    // if (this.profile.rcl_id === 4872) {
    //   this.sponsorIcons = [
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Syndeo.svg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Stripe.svg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Imagino.svg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Avalara.svg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Akeneo.png',
    //   ];
    // } else if (this.profile.rcl_id === 2579) {
    //   this.sponsorIcons = [
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_BlueYonder.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Contentful.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Navan.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Mirakl.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Tns.png',
    //   ];
    // } else if (this.profile.rcl_id === 6186 || this.profile.rcl_id === 6066) {
    //   this.sponsorIcons = [
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Asendia.jpg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_BlueYonder.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Bynder.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Kbrw.png',
    //   ];
    if (listProfile.current_list.sponsors.length > 0) {
      this.sponsorIcons = listProfile.current_list.sponsors.map((sponsor: any) => sponsor.logo);
    } else {
      this.sponsorIcons = [];
    }
  }

  toggleDownloadDialogList(version: 'list' | 'ranked-retailers' | null = null): void {
    this.displayExportDropdown = false; // Always hide dropdown
    if (version === 'list') {
      this.showListDownloadDialog = !this.showListDownloadDialog;
      this.showRankedRetailersDownloadDialog = false;
    } else if (version === 'ranked-retailers') {
      this.showRankedRetailersDownloadDialog = !this.showRankedRetailersDownloadDialog;
      this.showListDownloadDialog = false;
    } else {
      // used when closing via (closeDialog)
      this.showListDownloadDialog = false;
      this.showRankedRetailersDownloadDialog = false;
    }
  }

  toggleExportDropdownList() {
    this.displayExportDropdown = !this.displayExportDropdown

    if (this.displayExportDropdown) {
      setTimeout(() => {
        this.exportDropdown.nativeElement.focus()
      })

    }

  }

  redirectToExploreList() {
    location.href = `${environment.frontend_base}explore?search=${this.profile.current_list.name}&view=retailers`;
  }

  // urlCopiedNotification() {
  //   let msg = 'Url copied to clipboard';
  //
  //   let snackbar = this.snack.open(msg, '', {duration: 3000});
  // }

  // listNameChange(event: any) {
  //   location.href = `${environment.frontend_base}profile?slug=${event.slug}&id=${event.rcl}`;
  // }

  // redirectToExplore() {
  //   location.href = `${environment.frontend_base}explore?search=${this.profile.current_list.name}&view=retailers`;
  // }

  // redirectToPricing() {
  //   location.href = `${environment.wp.sign_up_url}`;
  // }

  // removePadlockText(element: HTMLElement): boolean {
  //   const width = element.offsetWidth;
  //   return width < 50;
  // }

  // toggleExportSpinner() {
  //   this.displayExportSpinner = !this.displayExportSpinner
  // }


  //LIST TEMPLATE FUNCTIONS END
}
